export default __webpack_public_path__ + "static/media/toraja.1856d343.mp4";